import type { I18n, Locale } from 'vue-i18n';
import { createI18n } from 'vue-i18n';
import Cookies from 'js-cookie';

import { COOKIE_KEY_LANGUAGE } from '@/summit/2023/constants';

function loadLanguage(prefix: string) {
  const lang = import.meta.glob("@/summit/2023/locales/*.y(a)?ml", { eager: true }) as Record<string, any>;
  const re = new RegExp(`/${prefix}\.`, 'i');

  const key = Object.keys(lang).find(item => item.match(re)) as string;

  return lang[key].default;
}

export const localesConfigs = {
  zh: {
    ...loadLanguage('zh'),
  },
  en: {
    ...loadLanguage('en'),
  },
};

let i18n: I18n<NonNullable<unknown>, NonNullable<unknown>, NonNullable<unknown>, Locale, false>;

export const getInstance = () => {
  if (!i18n) {
    const language = Cookies.get(COOKIE_KEY_LANGUAGE);

    i18n = createI18n({
      legacy: false,
      locale: language || 'zh',
      fallbackLocale: 'zh',
      messages: localesConfigs,
    });
  }

  return i18n;
}
